module.exports = __webpack_public_path__ + "img/sarcopenia.9f968ca4.svg";